import { render } from "./ViewUsage.vue?vue&type=template&id=539019a8&scoped=true&ts=true"
import script from "./ViewUsage.vue?vue&type=script&lang=ts"
export * from "./ViewUsage.vue?vue&type=script&lang=ts"

import "./ViewUsage.vue?vue&type=style&index=0&id=539019a8&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539019a8"]])

export default __exports__